export const HOTLINE_MODAL_PHONE_NUMBER = "48 579779333";
export const HOTLINE_CHATBOT_PROPERTY_PHONE_NUMBER = "48 739106256";
export const HOTLINE_CHATBOT_OFFER_PHONE_NUMBER = "48 739102111";
export const HOTLINE_INFO_PHONE_NUMBER = "48 579779123";
export const HOTLINE_VENDOR_REPORT_PHONE_NUMBER = "48 739106355";
